module.exports = __webpack_public_path__ + "static/img/icon cd wtfk.4fdfe31b.svg";